import React from 'react';
import { string, bool, node, oneOf, func, shape } from 'prop-types';
import { Message as AndesMessage } from '@andes/message';
import classnames from 'classnames';
import { validateSnackbarColor } from '../../utils/validators';
import MessageJsonAction from './json-actions';

const namespace = 'ui-pdp-message';
const namecolorspace = 'ui-pdp-background-color';

const Message = ({
  type,
  title,
  hierarchy,
  closeable,
  className,
  children,
  text,
  actionsPosition,
  actions,
  jsonActions,
  bgColor,
  runCatchErrorBoundary,
}) => {
  try {
    const actionsToRender = jsonActions ? (
      <div className="returns-notification__actions">
        {jsonActions.primary && (
          <MessageJsonAction
            text={jsonActions.primary.text}
            url={jsonActions.primary.url}
            hierarchy="loud"
            modalProps={{
              title: jsonActions.primary.modal?.title,
              closeLabel: jsonActions.primary.modal?.close_label,
              url: jsonActions.primary.modal?.url,
            }}
          />
        )}
        {jsonActions.secondary && (
          <MessageJsonAction
            buttonClassName={!jsonActions.primary ? 'link' : ''}
            text={jsonActions.secondary.text}
            url={jsonActions.secondary.url}
            hierarchy="transparent"
            modalProps={{
              title: jsonActions.secondary.modal?.title,
              closeLabel: jsonActions.secondary.modal?.close_label,
              url: jsonActions.secondary.modal?.url,
            }}
          />
        )}
      </div>
    ) : (
      actions
    );

    return (
      <AndesMessage
        className={classnames(namespace, className, {
          [`${namecolorspace}--${bgColor}`]: bgColor,
          [`${namespace}--closeable`]: closeable,
        })}
        color={validateSnackbarColor(type)}
        hierarchy={hierarchy}
        closable={closeable}
        title={title}
        actionsPosition={actionsPosition}
        actions={actionsToRender}
      >
        {text || children}
      </AndesMessage>
    );
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};

const ActionPropTypes = shape({
  modal: shape({
    title: string.isRequired,
    close_label: string.isRequired,
  }),
  target: oneOf(['_blank', '_self']),
  text: string.isRequired,
  url: string.isRequired,
});

Message.propTypes = {
  className: string,
  text: string,
  type: oneOf(['neutral', 'success', 'warning', 'error']),
  title: string,
  hierarchy: string,
  closeable: bool,
  children: node,
  actionsPosition: string,
  actions: node,
  jsonActions: shape({
    primary: ActionPropTypes,
    secondary: ActionPropTypes,
  }),
  bgColor: string,
  runCatchErrorBoundary: func,
};

Message.defaultProps = {
  className: null,
  title: null,
  text: null,
  type: 'neutral',
  hierarchy: 'quiet',
  closeable: false,
  actions: null,
  actionsPosition: 'bottom',
  bgColor: null,
  jsonActions: null,
  runCatchErrorBoundary: () => {},
};

export default Message;
